import React from 'react';

function StarIcon({ width = 11, height = 10, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 11 10">
      <g>
        <path d="M10.2290238,3.67144 C10.1620238,3.46544 9.97002377,3.32544 9.75302377,3.32544 L6.58302377,3.32544 L5.60202377,0.30944 C5.46702377,-0.10256 4.78602377,-0.10256 4.65102377,0.30944 L3.67002377,3.32544 L0.500023773,3.32544 C0.283023773,3.32544 0.0910237727,3.46544 0.0240237727,3.67144 C-0.0419762273,3.87744 0.0310237727,4.10344 0.206023773,4.23044 L2.77102377,6.09444 L1.79102377,9.11044 C1.72502377,9.31744 1.79802377,9.54244 1.97302377,9.66944 C2.14902377,9.79644 2.38502377,9.79644 2.56102377,9.66944 L5.12602377,7.80544 L7.69202377,9.66944 C7.78002377,9.73344 7.88202377,9.76544 7.98602377,9.76544 C8.08902377,9.76544 8.19202377,9.73344 8.28002377,9.66944 C8.45502377,9.54244 8.52802377,9.31744 8.46102377,9.11044 L7.48202377,6.09444 L10.0470238,4.23044 C10.2220238,4.10344 10.2950238,3.87744 10.2290238,3.67144" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default StarIcon;
